module.exports = "<div ng-transclude></div>\n<job-navbar id=\"matchMe\" default-tab=\"true\" ng-show=\"vm.showMatchMe\"></job-navbar>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/matchMe/matchMe.html
// module id = 152
// module chunks = 0 1